
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Dismiss24Regular } from '@fluentui/react-icons';
import {
  Button
} from '@fluentui/react-components';
import {
  OverlayDrawer,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody,
  DrawerFooter
} from '@fluentui/react-drawer';
import BulkLocations from './bulk-locations';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';

const BulkLocationsSearchDrawer = () => {
  const i18n = useContext(I18nContext);
  const {
    setIsDrawerOpen,
    isDrawerOpen,
    handleOnAddLocations,
    locationTargets,
    negativeLocationTargets,
    handlePanelClose,
  } = useBulkLocationsSearchContext();

  const submitIsEnabled = locationTargets.length > 0 || negativeLocationTargets.length > 0;

  return (
    <OverlayDrawer
      modalType="non-modal"
      size="medium"
      position="end"
      open={isDrawerOpen}
      onOpenChange={(_, { open }) => setIsDrawerOpen(open)}
      className="bulk-locations-search-drawer"
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label={i18n.getString(_TL_('Close'))}
              icon={<Dismiss24Regular />}
              onClick={() => handlePanelClose()}
            />
            }
        >
          {i18n.getString(_TL_('Add bulk locations'))}
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody>
        <BulkLocations />
      </DrawerBody>

      <DrawerFooter>
        <Button onClick={handleOnAddLocations} className="bulk-locations-add-button" disabled={!submitIsEnabled} appearance="primary">{i18n.getString(_TL_('Add locations'))}</Button>
        <Button onClick={() => handlePanelClose()}>{i18n.getString(_TL_('Cancel '))}</Button>
      </DrawerFooter>
    </OverlayDrawer>
  );
};

export default BulkLocationsSearchDrawer;
